import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
const TableResponsiveToggle = ({ className, onClick, ...other })=>/*#__PURE__*/ React.createElement("a", {
        onClick: (e)=>{
            e.preventDefault();
            onClick(e);
        },
        className: cx('Table-toggle', className),
        ...other
    }, /*#__PURE__*/ React.createElement("i", {
        className: "Icon Icon--plusCircle"
    }));
TableResponsiveToggle.propTypes = {
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * On responsive button click it will open/show row with hidden columns' data.
	 *
	 * @return {undefined}
	 */ onClick: PropTypes.func
};
TableResponsiveToggle.displayName = 'TableResponsiveToggle';
export default TableResponsiveToggle;
